import React from "react";
import { useRive } from "@rive-app/react-webgl2";

import "./RivePlayer01.css";

const RivePlayer = ({
  src,
  stateMachine = "State Machine 1",
  onRiveReady,
}) => {
  const { RiveComponent } = useRive({
    src: src,
    autoplay: true,
    stateMachines: stateMachine,
    onRiveReady,
  });

  return (
    <div className="RivePlayer01-wrapper">
      <RiveComponent />
    </div>
  );
};

export default RivePlayer;
